import { FC, useEffect, useState } from "react";
import PolicyItem from "components/PrivacyPolicyListing/PolicyItem";
import Seo from "components/Seo/Seo";
import { getAllTermsConditionsSections } from "services/api";
import { ITermsConditionsSection } from "services/models/index";

const TermsOfUsePage: FC<any> = () => {
  const [sections, setSections] = useState<ITermsConditionsSection[]>([]);
  const [loading, setLoading] = useState<boolean>(true);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    getAllTermsConditionsSections()
      .then((data: any) => {
        setSections(data);
        setLoading(false);
      })
      .catch((err: any) => {
        setError("Failed to fetch About Us sections");
        setLoading(false);
      });
  }, []);

  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>{error}</div>;
  }
  // Sort sections by order
  sections.sort((a, b) => (a.order || 0) - (b.order || 0));
  // Map sections to the existing texts structure
  const texts = sections.map((section) => ({
    title: section.title,
    text: section.text,
    icon: "exclamation-circle",
  }));

  return (
    <div
      className={`nc-PagePrivacyPolicy overflow-hidden relative`}
      data-nc-id="PagePrivacyPolicy"
    >
      <Seo
        name="Terms of use | Orbito Travel"
        description="Review Orbito Travel's terms of use for a clear understanding of your rights and responsibilities. Explore our policies regarding website usage, content, and services. Trust in our commitment to transparency and clarity as you explore accessible travel options with us."
        title="Terms of use | Orbito Travel"
        type="page"
      />
      <div className="container py-16 space-y-16 lg:space-y-28">
        <div className="w-screen max-w-full">
          <h2 className="text-3xl !leading-tight font-semibold text-neutral-900 md:text-4xl xl:text-5xl dark:text-neutral-100 mb-8">
            Terms of use
          </h2>
          <div className="block text-base xl:text-lg text-neutral-6000 dark:text-neutral-400">
            <div>
              {texts.map((text, index) => (
                <div key={index} className="listingSection__wrap mb-8">
                  {/* HEADING */}
                  <h2 className="text-2xl font-semibold">{text.title}</h2>
                  <div className="w-14 border-b border-neutral-200 dark:border-neutral-700"></div>

                  {/* ICON & TEXT */}
                  <div className="divide-y divide-neutral-100 dark:divide-neutral-800">
                    <div
                      className={`nc-PolicyItem flex space-x-4`}
                      data-nc-id="PolicyItem"
                    >
                      <div className="pt-0.5">
                        <i className={`la la-${text.icon} text-4xl`}></i>
                      </div>
                      <div className="flex-grow">
                        <div className="flex justify-between space-x-3">
                          <div className="flex flex-col">
                            <div className="text-sm font-semibold"></div>
                            <span className="text-sm text-neutral-500 dark:text-neutral-400 mt-0.5"></span>
                          </div>
                          <div className="flex text-yellow-500"></div>
                        </div>
                        <span
                          className="block mt-3 text-neutral-6000 dark:text-neutral-300"
                          dangerouslySetInnerHTML={{ __html: text.text }}
                        ></span>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfUsePage;
